var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-default page-action",attrs:{"type":"button","data-toggle":"modal","data-target":`#${_vm.target}`,"disabled":_vm.disabled}},[_c('i',{staticClass:"fa fa-file-excel-o"}),_vm._v(" "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }